import { images } from "../source";

export const bannerData = [
  {
    id: 1,
    img: images.homeBanner01.img,
    imgMb: images.homeBannerMb01.img,
    title: "CONNECTING THE WORLD WITH <br> <span>SEAMLESS LOGISTICS SOLUTIONS<span>",
    desc: "Your Trusted Partner in Freight Forwarding, Warehousing, and 3PL Services",
  },
];

export const servicesData = [
  {
    id: 1,
    img: images.airFreight.img,
    imgMb: images.airFreightMb.img,
    title: "Air Freight",
    desc: "Fast and reliable global air freight solutions for time-sensitive shipments.",
  },
  {
    id: 2,
    img: images.seaFreight.img,
    imgMb: images.seaFreightMb.img,
    title: "Sea Freight",
    desc: "Full range of sea freight services, including FCL, LCL, and bulk shipments.",
  },
  {
    id: 3,
    img: images.roadTransport.img,
    imgMb: images.roadTransportMb.img,
    title: "Road Transport",
    desc: "Efficient regional road transport services across the Middle East.",
  },
  {
    id: 4,
    img: images.warehouseStorage.img,
    imgMb: images.warehouseStorageMb.img,
    title: "Warehouse Storage",
    desc: "Secure, modern warehousing facilities with advanced inventory management systems.",
  },
];

export const coverFlowData = [
  {
    id: 1,
    img: images.chainManagement.img,
    title: "End-to-End Supply Chain Management",
    desc: "We handle all aspects of your logistics operations, from warehousing to distribution.",
  },
  {
    id: 2,
    img: images.orderManagement.img,
    title: "Order Management",
    desc: "Efficient processing and fulfillment of orders, ensuring timely delivery to customers.",
  },
  {
    id: 3,
    img: images.valueAddedServices.img,
    title: "Value-Added Services",
    desc: "Kitting, packaging, and customization services to meet specific client requirements.",
  },
  {
    id: 4,
    img: images.scalableSolutions.img,
    title: "Scalable Solutions",
    desc: "Flexible 3PL services that grow with your business needs and market demands.",
  },
];

export const commiteData = [
  {
    title: "Optimized Routes",
    content:
      "Efficient transportation planning to reduce fuel consumption and emissions.",
    img: images.optimizedRoute.img,
    imgMb: images.optimizedRouteMb.img,
  },
  {
    title: "Energy-Efficient Warehousing",
    content:
      "Implementation of sustainable practices in our storage facilities.",
    img: images.energyEfficientWarehousing.img,
    imgMb: images.energyEfficientWarehousingMb.img,
  },
  {
    title: "Eco-Friendly Packaging",
    content:
      "Use of recyclable and biodegradable materials for packaging solutions.",
    img: images.optimizedRoute.img,
    imgMb: images.optimizedRouteMb.img,
  },
  {
    title: "Carbon Footprint Reduction",
    content:
      "Continuous efforts to minimize environmental impact across all operations.",
    img: images.energyEfficientWarehousing.img,
    imgMb: images.energyEfficientWarehousingMb.img,
  },
];

export const keyStrengthData = [
  {
    id: 1,
    img: images.blueContainer.img,
    imgMb: images.blueContainerMb.img,
    title: "Strategic Location",
    desc: "Based in Dubai Airport Freezone, leveraging world-class infrastructure and global connectivity.",
  },
  {
    id: 2,
    img: images.skyBlueContainer.img,
    imgMb: images.skyBlueContainerMb.img,
    title: "Customizable Solutions",
    desc: "Tailor-made logistics services optimized for efficiency and cost-effectiveness.",
  },
  {
    id: 3,
    img: images.blueContainer.img,
    imgMb: images.blueContainerMb.img,
    title: "Advanced Technology",
    desc: "Cutting-edge software for real-time tracking, inventory management, and order processing.",
  },
  {
    id: 4,
    img: images.skyBlueContainer.img,
    imgMb: images.skyBlueContainerMb.img,
    title: "Dedicated <br> Team",
    desc: "Experienced logistics professionals committed to service excellence in every aspect.",
  },
];
